import React, { useEffect, useState } from "react";
import { BackButton, Toast } from "@egovernments/digit-ui-react-components";
import {
    MainWrapper,
    PrimaryTab,
    PrimaryTabs,
    PrimaryTabsWrapper,
    StyledDivider
} from "../../citizen/AVPForms/components/StyledComponent";
import EmpTopBar from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/EmpTopBar";
import useEmpMapSubmission from "./useEmpMapSubmission";
import ViewDocuments from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/ViewDocuments";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { formMTDocActions } from "@egovernments/digit-ui-module-core/src/redux/actions";
import AllRemarksList from "../../../../../templates/Forms/AllRemarks";
import Step1 from "../../citizen/AVPForms/formComponents/resedential-self/Step1";
import Step3 from "../../citizen/AVPForms/formComponents/resedential-self/Step3";
import PrimaryContent from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/PrimaryContent";
import CollapsibleHistory from "../NotingRemarks";
import OnSelectActionDropdown from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/OnSelectActionDropdown";
import RemarksEditor from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/RemarksEditor";
import DocUploader from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/DocUploader";
import SubmitButton from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/SubmitButton";

const EmpSelfRegistration = ({ formData, refetch, submitAction, workflowDetails, userRolesArray }) => {
  const dispatch = useDispatch();
  const { initFormMTDocs } = bindActionCreators(formMTDocActions, dispatch);
  const [activeTab, setActiveTab] = useState(Digit?.SessionStorage.get("SELF_CURRENT_TAB") || 0);
  const [selectedSubTab, setSelectedSubTab] = useState(Digit?.SessionStorage.get("SELF_CURRENT_SUBTAB") || 0);
  const [selectedDocTab, setSelectedDocTab] = useState(0);
  const [showToast, setShowToast] = useState(null);

  const {
    currentAction,
    Modal,
    actions,
    handleSubmit,
    error,
    setError,
    isCitizen,
    updateApiCall,
    t,
    remarks,
    setRemarks,
    documentSection,
    setIsPreviewLoading,
    iframeSrc,
    setIframeSrc,
    initialUrl,
    developerRemarks,
    setDeveloperRemarks,
    callNotingDetailsAPI,
    uploadedFile,
    setUploadedFile,
    notingRemarksData,
    onDropDownSelect,
    mapSubmissionAction,
    params,
    onSelect,
  } = useEmpMapSubmission(formData, refetch, workflowDetails, userRolesArray);
  const closeToast = () => {
    setShowToast(null);
  };

  useEffect(() => {
    if (formData?.documents?.length > 0) {
      initFormMTDocs(formData.documents);
    }
  }, []);
  const handleTabChange = async (nextTabNo, formData = null) => {
    if(formData){
       const data = { ...params, ...formData };
    try {
      data.workflow = { action: "NOWORKFLOW", assignes: null };
      updateApiCall.mutate(
        { BPA: data },
        {
          onSuccess: (res) => {
            onSelect("", res?.BPA?.[0]);
            Modal("Application Updated", `Application Updated Successfully!`, "success");
          },
          onError: () => {
            Modal("Update Error", "Something went wrong!!", "error");
          },
        }
      );
    } catch (error) {
      console.error(error);
      Modal("Update Error", "Something went wrong!!", "error");
    }
    }
    setActiveTab(nextTabNo);
    Digit.SessionStorage.set("SELF_CURRENT_TAB", nextTabNo);
  };
 
  const renderContent = () => {
    console.log("activeTabFromRender", activeTab);

    if (activeTab === 0) {
      return <Step1 formData={formData} handleTabChange={handleTabChange} isEmployee={!isCitizen} />;
    } else if (activeTab === 1) {
      return <Step3 formData={formData} handleTabChange={handleTabChange} isEmployee={!isCitizen} />
    }
    else if (activeTab === 2) {
      return (
        <React.Fragment>
          <ViewDocuments
            documentSection={documentSection}
            setIsPreviewLoading={setIsPreviewLoading}
            iframeSrc={iframeSrc}
            setIframeSrc={setIframeSrc}
            initialUrl={initialUrl}
          />
        </React.Fragment>
      );
    }
    else if (activeTab === 3) {
      return (
          <React.Fragment>
          <PrimaryContent formData={formData} handleChange={handleTabChange} serviceName={"Map Submission"} />
          <CollapsibleHistory
            formData={formData}
            callNotingDetailsAPI={callNotingDetailsAPI}
            developerRemarks={developerRemarks}
            setDeveloperRemarks={setDeveloperRemarks}
            notingRemarksData={notingRemarksData}
          />

          <OnSelectActionDropdown currentAction={currentAction || mapSubmissionAction || " "} onChange={onDropDownSelect} actions={actions} />
          <RemarksEditor setRemarks={setRemarks} remarks={remarks} setError={setError} error={error} />
          <DocUploader uploadedFile={uploadedFile} setUploadedFile={setUploadedFile} />
          {formData?.status === "APPROVED" &&
            <SubmitButton handleSubmit={handleSubmit} isLoading={updateApiCall.isLoading} />
          }
        </React.Fragment>
      );
    }
      else if (activeTab === 4) {
      return (
        <React.Fragment>
          <AllRemarksList remarkDataResps={workflowDetails?.data} />
        </React.Fragment>
      );
    }
  };

  return (
    <MainWrapper>
      {/* <HeaderContent applicationFlow={applicationFlow} /> */}
      <BackButton />
      <EmpTopBar formData={formData} />
      <PrimaryTabsWrapper>
        {/* Tabs Header */}
        <PrimaryTabs value={activeTab} onChange={(e, i) => handleTabChange(i)} aria-label="Tab Group" variant="fullWidth">
          <PrimaryTab label="Application Form" />
          <PrimaryTab label="Details of Map" />
          <PrimaryTab label="Documents" />
          <PrimaryTab label="Take Action" />
          <PrimaryTab label="All Remarks" />
        </PrimaryTabs>
      </PrimaryTabsWrapper>
      <StyledDivider />
      {renderContent()}
      {showToast && (
        <Toast error={showToast?.error} warning={showToast?.warning} label={t(showToast?.message)} onClose={closeToast} isDleteBtn={true} />
      )}
    </MainWrapper>
  );
};

export default EmpSelfRegistration;
